<template>
  <div class="order-site-distribution" v-loading="loading">
    <gj-analysis-panel
        :title="'订单站点分布与订单量累计分布'"
    >
      <template #subtitle>
        <gj-select
            v-model="distributionFilter.orderType"
            :options="option.orderTypeOptions"
            :clearable="false"
            @input="changeOrderType"
            :style="{margin: '0 14px'}"
        ></gj-select>
        <span class="left-option-header-time">
          {{startDate}} ~ {{endDate}} {{dateShortcut | defaultShow('| ', '', '')}}
        </span>
      </template>
      <template #rightContainer>
        <OptionGroup
            :show-list= "['refresh']"
            @refresh="refresh"
            :showPanelBtn="true"
            :isShowPanel="isShowPanel"
            @showPanel="showPanel"
        />
      </template>
      <template #panelBody>
        <div class="order-site-distribution-content">
          <el-row :gutter="10">
            <el-col :span="14" v-if="!isShowPanel">
              <el-card class="box-card card460">
                <Chart :type="'bar'" :option="orderSiteDistributionOption" :height="'420px'" />
              </el-card>
            </el-col>
            <el-col :span="24" v-if="isShowPanel">
              <div class="panel-group">
                <div class="panel-left-group">
                  <div class="panel-group-left">
                    <img src="../../../../../assets/images/panel/orderSiteDistributionLeft@1x.png" />
                  </div>
                  <div class="panel-group-middle">
                    <img src="../../../../../assets/images/panel/orderSiteDistributionMiddle@1x.png" />
                  </div>
                </div>

                <div class="panel-group-right">
                  <img src="../../../../../assets/images/panel/orderSiteDistributionRight@1x.png" />
                </div>
              </div>
              <div class="panel-group-right-btn-group">
                <gj-button class="panel-group-right-btn" :style="{float: 'right'}" @click="showPanel(false)">返回看板</gj-button>
              </div>
            </el-col>
            <el-col :span="10" v-if="!isShowPanel">
              <el-card class="box-card card460">
                <div class="order-ratio-group">
                  <div class="order-ratio" v-for="(item, index) in percentListData" :key="index">
                    <el-row>
                      <el-col :span="4" class="percentText">
                        {{item.country}}
                      </el-col>
                      <el-col :span="16">
                        <el-progress :text-inside="true" :stroke-width="14" :percentage="item.per"></el-progress>
                      </el-col>
                      <el-col :span="4"  class="percentText" style="text-align: right">
                        {{parseInt(item.orders)}}
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </template>
    </gj-analysis-panel>
  </div>
</template>

<script>
import Chart from "@/views/components/chart/chart"
import OptionGroup from "@/views/components/option-panel-group/option-group"
import {getOrderDistributedData} from "@/api/statistics"
import {orderTypeOptions} from "@/utils/options";
import {convertToFullDate, dateShortcut} from "@/utils/date.util";
import _ from "lodash";

export default {
  name: "order-site-distribution",
  components: { Chart, OptionGroup},
  inject: ['getPageParams'],

  data(){
    return{
      useCache: false,
      loading: false,
      //是否显示看板
      isShowPanel: false,
      orderSiteDistributionOption: {},
      option:{
        orderTypeOptions: orderTypeOptions
      },
      // data: ["US","US","US","US","US"],
      //图表x轴坐标
      xAxisData: [],
      //图表series数据
      seriesData: [],
      //右侧图表数据集合
      percentListData:[],
      distributionFilter:{
        orderType: "ALL",
      }
    }
  },
  computed: {
    startDate() {
       let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[0], dateFormat) : null;
    },
    endDate() {
       let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[1], dateFormat) : null;
    },
    dateShortcut() {
      return dateShortcut(this.filter.date.key === 0?this.filter.date.value:'');
    },
    filter () {
      return this.getPageParams()
    }
  },
  mounted() {
    this.initOrderSiteDistributionOptionParams();
    this.$gjQuery()
  },
  watch: {

  },
  methods: {
    /**
     * 获取全部初始化界面数据
     */
    $gjQuery(){
      this.getOrderDistributedData();
    },
    /**
     * 刷新界面
     */
    refresh(){
      this.$gjQuery();
    },
    /**
     *  显示看板
     */
    showPanel(value){
      this.isShowPanel = value;
    },
    /**
     *  切换订单选择
     *  type 0 全部订单 1 促销订单
     */
    changeOrderType(type){
      this.distributionFilter.orderType = type;
      this.getOrderDistributedData(type);
    },
    /**
     * 获取销售分析-订单站点分布与订单累计分布
     */
    getOrderDistributedData(type){
      let params = {
        ...this.filter,
        countryCodes: this.filter.countryMarketValue ? this.filter.countryMarketValue.countryIds : null,
        marketIds : this.filter.countryMarketValue ? !_.isEmpty(this.filter.countryMarketValue.marketIds) ? this.filter.countryMarketValue.marketIds: null : null,
      }
      if(type){
        params.orderType = type;
      }
      params = _.omit(params,["date","countryMarketValue","id"]);
      this.loading = true;
      getOrderDistributedData(params).then((res) =>{
        let data = res;
        //1、拼装左侧图表数据
        let xAxisData = [],seriesData =[];
        let seriesListOne = [],seriesListTwo = [];
        let yMaxLeft = 0, yMaxRight =0;
        for(let i=0;i<data.length;i++){
          yMaxLeft = yMaxLeft >_.toNumber(data[i].orders) ? yMaxLeft: _.toNumber(data[i].orders);
          yMaxRight = yMaxRight >_.toNumber(data[i].per)*100 ? yMaxRight: _.toNumber(data[i].per) * 100;
          xAxisData.push(data[i].country);
          seriesListOne.push(data[i].orders);
          let iTotal = 0;
          for(let j=0;j<i+1;j++){
            iTotal += _.round(_.toNumber(data[j].per) *100,2)
          }
          seriesListTwo.push(iTotal);
        }
        seriesData = [
          {
            name: '订单量',
            type: 'bar',
            stack: 'orderDistributed',
            barMaxWidth: "30",
            data: seriesListOne
          },
          {
            name: '订单累计分布',
            type: 'line',
            stack: 'orderDistributed1',
            yAxisIndex: 1,
            color: '#FA7A7A',
            data: seriesListTwo
          }
        ]
        this.xAxisData = xAxisData;
        this.seriesData = seriesData;
        //重绘
        this.initOrderSiteDistributionOptionParams(xAxisData, seriesData, yMaxLeft, yMaxRight);
        // 2、拼装右侧图表数据,后端会排好序，取前5个即可
        this.percentListData = data.slice(0,5);
        _.map(this.percentListData, v=>{
          v.per = _.round(_.toNumber(v.per)*100,2)
        })
      }).complete(()=>{this.loading = false})
    },
    /**
     * 设置图表参数
     */
    initOrderSiteDistributionOptionParams(xAxisData, seriesData, yMaxLeft, yMaxRight){
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter:function(params){
            let str = '';
            params.map((v,idx)=>{
              if(idx ===0){
                str += v.name + "<br/>";
              }
              str += v.marker + v.seriesName + ":    ";
              if(idx ===1){
                str += v.value +"%" + "<br/>";
              } else {
                str += v.value + "<br/>";
              }
            })
            return str;
          }
        },
        color: ['#1F6EEF'],
        legend: {
          data: ['订单量', '订单累计分布'],
          top: '0%',
          itemGap: 10,
          icon: "rect",
          itemWidth: 15,
          itemHeight: 3,
          textStyle: {
            color: '#888',
            padding: [2, 0, 0, 0],
          }
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
            axisPointer: {
              type: 'shadow'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#e5e9f2"
              }
            },
            axisLabel: {
              margin: 10,
              color: "#32393d"
            },
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '订单量',
            nameTextStyle:{
              color: "#32393d"
            },
            axisLabel: {
              margin: 10,
              color: "#32393d",
              formatter: '{value}'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#e5e9f2"
              }
            },
            min: 0,
            interval: _.ceil(yMaxLeft/5),
            max: yMaxLeft
          },
          {
            type: 'value',
            name: '订单累计分布',
            nameTextStyle:{
              color: "#32393d"
            },
            axisLabel: {
              margin: 10,
              color: "#32393d",
              formatter: '{value} %'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#e5e9f2"
              }
            },
            min: 0,
            interval: 20,
            max: 100
          }
        ],
        series: seriesData
      };
      this.orderSiteDistributionOption = option;
    },
  }
}
</script>

<style lang="scss"  scoped>
@import "../common/index.scss";
.order-site-distribution{
  margin-top: 10px;
  padding: 0 0;
}
.order-ratio-group{
  height: 380px;
  overflow-y:auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .order-ratio{
    margin-bottom: 15px;
  }
  .percentText{
      font-size: 14px;
    }
}

.panel-group{
  width: 100%;
  //height: 100%;
  height: 420px;
  min-height: 342px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  .panel-left-group{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .panel-group-middle{
      margin-left: 30px;
    }
  }
  .panel-group-right{
    text-align: center;
    img{
      width: 100%;
      height: 278px;
    }
  }
}
/deep/ .el-progress-bar__innerText {
  margin-bottom: 3px;
}
</style>
